import { api } from "./client";

export interface AuditLog {
  id: string;
  user_id: string | null;
  user_email: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  meta: string | null;
  ip: string | null;
  created_at: string;
}

export const auditApi = {
  list: (params?: {
    limit?: number;
    before?: string;
    userId?: string;
    action?: string;
    resourceType?: string;
  }) => {
    const qs = new URLSearchParams();
    if (params?.limit)        qs.set("limit", String(params.limit));
    if (params?.before)       qs.set("before", params.before);
    if (params?.userId)       qs.set("userId", params.userId);
    if (params?.action)       qs.set("action", params.action);
    if (params?.resourceType) qs.set("resourceType", params.resourceType);
    return api.get<AuditLog[]>(`/api/audit?${qs}`);
  },

  actions: () => api.get<string[]>("/api/audit/actions"),
};
